
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as helpshQ9HmYckGxqBPhPrCbPSLWoTXLDq97DRjAMFWNraLAMeta } from "/app/app/pages/help.vue?macro=true";
import { default as shopP67r7ebj8gCii7gWGgkzBAQhR_Kfd7sBZH0Y7J65mp4Meta } from "/app/app/pages/shop.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta } from "/app/app/pages/login.vue?macro=true";
import { default as carrito06eWEiakAgp7Hbfjd5j9e2VwEOA8D4MMzQQCpb51geIMeta } from "/app/app/pages/carrito.vue?macro=true";
import { default as checkoutFLMN_AaNxnM_h9ALAUimIAaWpDkJA4XoG0OMrXZi_WgMeta } from "/app/app/pages/checkout.vue?macro=true";
import { default as _91slug_93t68n6mFljm7uRTbD3rnuKIA6mppsU3X3ChgElaVRMGAMeta } from "/app/app/pages/p/[slug].vue?macro=true";
import { default as _91code_93B18f0zZywCUaeKa9g8asUKQXLTmZPVhKICO46YwtlFwMeta } from "/app/app/pages/r/[code].vue?macro=true";
import { default as registerhPH0MU2Juf_wsbIztPgIOhf1JmD4z1RPu17er_DhMMAMeta } from "/app/app/pages/register.vue?macro=true";
import { default as indexkcnxUqDL5l3uCWG3ZNXMlgKyZy0Msueh4TDWa9hRAVEMeta } from "/app/app/pages/compramos/index.vue?macro=true";
import { default as step_4522L0BDqezog0BYcgPXSCXL6SBu98K8Hw9KhA3__x_N3QMeta } from "/app/app/pages/compramos/step-2.vue?macro=true";
import { default as step_453770w4FibyxzD5ihHoHRZn72LSrT70WXuPevTwHBVvtEMeta } from "/app/app/pages/compramos/step-3.vue?macro=true";
import { default as step_454_fcahjikC9XaULAsqdNfzTpuvAazarROn5WNMYkHOcEMeta } from "/app/app/pages/compramos/step-4.vue?macro=true";
import { default as step_4554ChtEDFaWjnKtte_b_aLPuc37wcZ5KGFbT_fYx9MjEMMeta } from "/app/app/pages/compramos/step-5.vue?macro=true";
import { default as compramos08veRAaDYbEbqJn_tQWZuhcRtz8ABwgrDSQP6t4o0_IMeta } from "/app/app/pages/compramos.vue?macro=true";
import { default as indexv2yp_toDb5EUK8ku_QAWpOo627WINk_K3_nAWa_ufBUMeta } from "/app/app/pages/blog/index.vue?macro=true";
import { default as _91slug_933j3aB90NQpbcgM9m38rZZJF0c2jXm3_tW_8yP_2rP7YMeta } from "/app/app/pages/blog/[slug].vue?macro=true";
import { default as indexpKJ_j0pkXSnatzg99zbK_o26G4u2WaEUZFgYeTk6V5AMeta } from "/app/app/pages/cuenta/index.vue?macro=true";
import { default as index8V_SsD1HA7K4oyojmUXx5gN9YwrlYFqORnicK8O9gB8Meta } from "/app/app/pages/restauracion/index.vue?macro=true";
import { default as step_4525oEzNxXscDEizwiaxQ_zA__8CrI8UdAucjvvrJrJ7M8Meta } from "/app/app/pages/restauracion/step-2.vue?macro=true";
import { default as step_453u_XYcepYS4PnXqukSlvp4noz__31RYyTRsefY2TxNFwMeta } from "/app/app/pages/restauracion/step-3.vue?macro=true";
import { default as step_454HJj1yrIQaGfx77CJ1DaeQYd1IxdWcd_ocrKQGidw5T0Meta } from "/app/app/pages/restauracion/step-4.vue?macro=true";
import { default as restauracionpC9gzQWJISO4SKDuTrzr6NxLccRysAqDJTciviJY8GkMeta } from "/app/app/pages/restauracion.vue?macro=true";
import { default as design_45systemi_3OA6T2BiaZPUMI68m9W3jJWuPw7PfeLsIrXzzXpEkMeta } from "/app/app/pages/design-system.vue?macro=true";
import { default as profilec_W8OHXjvT6nF99_4GG9t9r0TT_TGxGB5VCXD7H5I34Meta } from "/app/app/pages/cuenta/profile.vue?macro=true";
import { default as reset_45passwordRWC8pxhff1LJdRqCJLmpSqWklySmk6cvsFKzT6u_OosMeta } from "/app/app/pages/reset-password.vue?macro=true";
import { default as _91slug_93HS62YUor6WZ0_TsyOkK8_rttolYtigu7zQW5GdR0_pUMeta } from "/app/app/pages/blog/tag/[slug].vue?macro=true";
import { default as forgot_45password_svvr_HXOSYgUMkqXVPpKJfwi_QEp8hjfRcKoAib3NwMeta } from "/app/app/pages/forgot-password.vue?macro=true";
import { default as _91slug_939IKtVpAoEGPyl6eNoW6Eav287llDroNYdsV6OAeNXLYMeta } from "/app/app/pages/producto/[slug].vue?macro=true";
import { default as addressesgA068qv_jjPyl2rEEHtcx_yKf7GRFGr4xxq8fa_EWVMMeta } from "/app/app/pages/cuenta/addresses.vue?macro=true";
import { default as _91id_93ljw4oHscF_0JU1NjE84NcoFbmBhNrj_j8LGCoKm_QN4Meta } from "/app/app/pages/blog/preview/[id].vue?macro=true";
import { default as _91id_93E4_n4ZvBQs2u9XLfe7atCPLMbqNB3avJYwMCa45Cs9UMeta } from "/app/app/pages/cuenta/orders/[id].vue?macro=true";
import { default as indexA1Z4n6yr5Usqsa82fOa6jRmBnfpCBYIZRndEOZ6Pof0Meta } from "/app/app/pages/cuenta/orders/index.vue?macro=true";
import { default as _91slug_93QQlsz0WWHjGA4Kg0Guhq64cNKXMAutOEtmOSnzj0uJwMeta } from "/app/app/pages/blog/category/[slug].vue?macro=true";
import { default as index3Qvr8laYRvJ5VA5BVbMRS1qnrDNW4aif7Ey_t9gwaGsMeta } from "/app/app/pages/cuenta/afiliados/index.vue?macro=true";
import { default as pagosL_oZeUl7p21d0CMb1Zh25xxkvjaOjro2n_k3zXQIN28Meta } from "/app/app/pages/cuenta/afiliados/pagos.vue?macro=true";
import { default as _91id_93F7rcEIxtWJtG6XKmI0DYbJQIu9Wb44c5siLXxLsY948Meta } from "/app/app/pages/cuenta/sell-orders/[id].vue?macro=true";
import { default as pedidosnKcc6GeRUWing_9XZR_qlQ4l0Z8_CeMZhg0G1fIMAqsMeta } from "/app/app/pages/cuenta/afiliados/pedidos.vue?macro=true";
import { default as indexaZd5suxscPL8PeEioAeZellF6W0buzj0w6lxtDdr1VgMeta } from "/app/app/pages/cuenta/sell-orders/index.vue?macro=true";
import { default as disputasFhwRzT4lspSzAcgDytBL8Ofjob_U7HTwjIvRuwT2ceQMeta } from "/app/app/pages/cuenta/afiliados/disputas.vue?macro=true";
import { default as _91id_93bRMjVP6vwniJw7xx_J3wvBqfQJwRuBzTt0V2iOkebU4Meta } from "/app/app/pages/cuenta/repair-orders/[id].vue?macro=true";
import { default as solicitudqkjloHtiYXll1Madjfahce6HB4qMt5khUAdw9Wv1bHwMeta } from "/app/app/pages/cuenta/afiliados/solicitud.vue?macro=true";
import { default as indexuyjqovXJbNEALsC2UmwLPsPoPmtMcQ_BiO5ISa81DRcMeta } from "/app/app/pages/cuenta/repair-orders/index.vue?macro=true";
import { default as comisionesZpwqZB2EL06Wa38MWYx3SLWWBFAjxr_3etcjkBkfFZ4Meta } from "/app/app/pages/cuenta/afiliados/comisiones.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "help___es",
    path: "/help",
    component: () => import("/app/app/pages/help.vue")
  },
  {
    name: "help___en",
    path: "/en/help",
    component: () => import("/app/app/pages/help.vue")
  },
  {
    name: "help___pt",
    path: "/pt/help",
    component: () => import("/app/app/pages/help.vue")
  },
  {
    name: "help___zh",
    path: "/zh/help",
    component: () => import("/app/app/pages/help.vue")
  },
  {
    name: "help___fr",
    path: "/fr/help",
    component: () => import("/app/app/pages/help.vue")
  },
  {
    name: "shop___es",
    path: "/shop",
    meta: shopP67r7ebj8gCii7gWGgkzBAQhR_Kfd7sBZH0Y7J65mp4Meta || {},
    component: () => import("/app/app/pages/shop.vue")
  },
  {
    name: "shop___en",
    path: "/en/shop",
    meta: shopP67r7ebj8gCii7gWGgkzBAQhR_Kfd7sBZH0Y7J65mp4Meta || {},
    component: () => import("/app/app/pages/shop.vue")
  },
  {
    name: "shop___pt",
    path: "/pt/shop",
    meta: shopP67r7ebj8gCii7gWGgkzBAQhR_Kfd7sBZH0Y7J65mp4Meta || {},
    component: () => import("/app/app/pages/shop.vue")
  },
  {
    name: "shop___zh",
    path: "/zh/shop",
    meta: shopP67r7ebj8gCii7gWGgkzBAQhR_Kfd7sBZH0Y7J65mp4Meta || {},
    component: () => import("/app/app/pages/shop.vue")
  },
  {
    name: "shop___fr",
    path: "/fr/shop",
    meta: shopP67r7ebj8gCii7gWGgkzBAQhR_Kfd7sBZH0Y7J65mp4Meta || {},
    component: () => import("/app/app/pages/shop.vue")
  },
  {
    name: "index___es",
    path: "/",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "login___es",
    path: "/login",
    meta: logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta || {},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta || {},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "login___pt",
    path: "/pt/login",
    meta: logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta || {},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "login___zh",
    path: "/zh/login",
    meta: logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta || {},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta || {},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "carrito___es",
    path: "/carrito",
    meta: carrito06eWEiakAgp7Hbfjd5j9e2VwEOA8D4MMzQQCpb51geIMeta || {},
    component: () => import("/app/app/pages/carrito.vue")
  },
  {
    name: "carrito___en",
    path: "/en/carrito",
    meta: carrito06eWEiakAgp7Hbfjd5j9e2VwEOA8D4MMzQQCpb51geIMeta || {},
    component: () => import("/app/app/pages/carrito.vue")
  },
  {
    name: "carrito___pt",
    path: "/pt/carrito",
    meta: carrito06eWEiakAgp7Hbfjd5j9e2VwEOA8D4MMzQQCpb51geIMeta || {},
    component: () => import("/app/app/pages/carrito.vue")
  },
  {
    name: "carrito___zh",
    path: "/zh/carrito",
    meta: carrito06eWEiakAgp7Hbfjd5j9e2VwEOA8D4MMzQQCpb51geIMeta || {},
    component: () => import("/app/app/pages/carrito.vue")
  },
  {
    name: "carrito___fr",
    path: "/fr/carrito",
    meta: carrito06eWEiakAgp7Hbfjd5j9e2VwEOA8D4MMzQQCpb51geIMeta || {},
    component: () => import("/app/app/pages/carrito.vue")
  },
  {
    name: "checkout___es",
    path: "/checkout",
    meta: checkoutFLMN_AaNxnM_h9ALAUimIAaWpDkJA4XoG0OMrXZi_WgMeta || {},
    component: () => import("/app/app/pages/checkout.vue")
  },
  {
    name: "checkout___en",
    path: "/en/checkout",
    meta: checkoutFLMN_AaNxnM_h9ALAUimIAaWpDkJA4XoG0OMrXZi_WgMeta || {},
    component: () => import("/app/app/pages/checkout.vue")
  },
  {
    name: "checkout___pt",
    path: "/pt/checkout",
    meta: checkoutFLMN_AaNxnM_h9ALAUimIAaWpDkJA4XoG0OMrXZi_WgMeta || {},
    component: () => import("/app/app/pages/checkout.vue")
  },
  {
    name: "checkout___zh",
    path: "/zh/checkout",
    meta: checkoutFLMN_AaNxnM_h9ALAUimIAaWpDkJA4XoG0OMrXZi_WgMeta || {},
    component: () => import("/app/app/pages/checkout.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    meta: checkoutFLMN_AaNxnM_h9ALAUimIAaWpDkJA4XoG0OMrXZi_WgMeta || {},
    component: () => import("/app/app/pages/checkout.vue")
  },
  {
    name: "p-slug___es",
    path: "/p/:slug()",
    component: () => import("/app/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___en",
    path: "/en/p/:slug()",
    component: () => import("/app/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___pt",
    path: "/pt/p/:slug()",
    component: () => import("/app/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___zh",
    path: "/zh/p/:slug()",
    component: () => import("/app/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___fr",
    path: "/fr/p/:slug()",
    component: () => import("/app/app/pages/p/[slug].vue")
  },
  {
    name: "r-code___es",
    path: "/r/:code()",
    meta: _91code_93B18f0zZywCUaeKa9g8asUKQXLTmZPVhKICO46YwtlFwMeta || {},
    component: () => import("/app/app/pages/r/[code].vue")
  },
  {
    name: "r-code___en",
    path: "/en/r/:code()",
    meta: _91code_93B18f0zZywCUaeKa9g8asUKQXLTmZPVhKICO46YwtlFwMeta || {},
    component: () => import("/app/app/pages/r/[code].vue")
  },
  {
    name: "r-code___pt",
    path: "/pt/r/:code()",
    meta: _91code_93B18f0zZywCUaeKa9g8asUKQXLTmZPVhKICO46YwtlFwMeta || {},
    component: () => import("/app/app/pages/r/[code].vue")
  },
  {
    name: "r-code___zh",
    path: "/zh/r/:code()",
    meta: _91code_93B18f0zZywCUaeKa9g8asUKQXLTmZPVhKICO46YwtlFwMeta || {},
    component: () => import("/app/app/pages/r/[code].vue")
  },
  {
    name: "r-code___fr",
    path: "/fr/r/:code()",
    meta: _91code_93B18f0zZywCUaeKa9g8asUKQXLTmZPVhKICO46YwtlFwMeta || {},
    component: () => import("/app/app/pages/r/[code].vue")
  },
  {
    name: "register___es",
    path: "/register",
    meta: registerhPH0MU2Juf_wsbIztPgIOhf1JmD4z1RPu17er_DhMMAMeta || {},
    component: () => import("/app/app/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registerhPH0MU2Juf_wsbIztPgIOhf1JmD4z1RPu17er_DhMMAMeta || {},
    component: () => import("/app/app/pages/register.vue")
  },
  {
    name: "register___pt",
    path: "/pt/register",
    meta: registerhPH0MU2Juf_wsbIztPgIOhf1JmD4z1RPu17er_DhMMAMeta || {},
    component: () => import("/app/app/pages/register.vue")
  },
  {
    name: "register___zh",
    path: "/zh/register",
    meta: registerhPH0MU2Juf_wsbIztPgIOhf1JmD4z1RPu17er_DhMMAMeta || {},
    component: () => import("/app/app/pages/register.vue")
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: registerhPH0MU2Juf_wsbIztPgIOhf1JmD4z1RPu17er_DhMMAMeta || {},
    component: () => import("/app/app/pages/register.vue")
  },
  {
    name: compramos08veRAaDYbEbqJn_tQWZuhcRtz8ABwgrDSQP6t4o0_IMeta?.name,
    path: "/compramos",
    meta: compramos08veRAaDYbEbqJn_tQWZuhcRtz8ABwgrDSQP6t4o0_IMeta || {},
    component: () => import("/app/app/pages/compramos.vue"),
    children: [
  {
    name: "compramos___es",
    path: "",
    component: () => import("/app/app/pages/compramos/index.vue")
  },
  {
    name: "compramos-step-2___es",
    path: "step-2",
    component: () => import("/app/app/pages/compramos/step-2.vue")
  },
  {
    name: "compramos-step-3___es",
    path: "step-3",
    component: () => import("/app/app/pages/compramos/step-3.vue")
  },
  {
    name: "compramos-step-4___es",
    path: "step-4",
    component: () => import("/app/app/pages/compramos/step-4.vue")
  },
  {
    name: "compramos-step-5___es",
    path: "step-5",
    component: () => import("/app/app/pages/compramos/step-5.vue")
  }
]
  },
  {
    name: compramos08veRAaDYbEbqJn_tQWZuhcRtz8ABwgrDSQP6t4o0_IMeta?.name,
    path: "/en/compramos",
    meta: compramos08veRAaDYbEbqJn_tQWZuhcRtz8ABwgrDSQP6t4o0_IMeta || {},
    component: () => import("/app/app/pages/compramos.vue"),
    children: [
  {
    name: "compramos___en",
    path: "",
    component: () => import("/app/app/pages/compramos/index.vue")
  },
  {
    name: "compramos-step-2___en",
    path: "step-2",
    component: () => import("/app/app/pages/compramos/step-2.vue")
  },
  {
    name: "compramos-step-3___en",
    path: "step-3",
    component: () => import("/app/app/pages/compramos/step-3.vue")
  },
  {
    name: "compramos-step-4___en",
    path: "step-4",
    component: () => import("/app/app/pages/compramos/step-4.vue")
  },
  {
    name: "compramos-step-5___en",
    path: "step-5",
    component: () => import("/app/app/pages/compramos/step-5.vue")
  }
]
  },
  {
    name: compramos08veRAaDYbEbqJn_tQWZuhcRtz8ABwgrDSQP6t4o0_IMeta?.name,
    path: "/pt/compramos",
    meta: compramos08veRAaDYbEbqJn_tQWZuhcRtz8ABwgrDSQP6t4o0_IMeta || {},
    component: () => import("/app/app/pages/compramos.vue"),
    children: [
  {
    name: "compramos___pt",
    path: "",
    component: () => import("/app/app/pages/compramos/index.vue")
  },
  {
    name: "compramos-step-2___pt",
    path: "step-2",
    component: () => import("/app/app/pages/compramos/step-2.vue")
  },
  {
    name: "compramos-step-3___pt",
    path: "step-3",
    component: () => import("/app/app/pages/compramos/step-3.vue")
  },
  {
    name: "compramos-step-4___pt",
    path: "step-4",
    component: () => import("/app/app/pages/compramos/step-4.vue")
  },
  {
    name: "compramos-step-5___pt",
    path: "step-5",
    component: () => import("/app/app/pages/compramos/step-5.vue")
  }
]
  },
  {
    name: compramos08veRAaDYbEbqJn_tQWZuhcRtz8ABwgrDSQP6t4o0_IMeta?.name,
    path: "/zh/compramos",
    meta: compramos08veRAaDYbEbqJn_tQWZuhcRtz8ABwgrDSQP6t4o0_IMeta || {},
    component: () => import("/app/app/pages/compramos.vue"),
    children: [
  {
    name: "compramos___zh",
    path: "",
    component: () => import("/app/app/pages/compramos/index.vue")
  },
  {
    name: "compramos-step-2___zh",
    path: "step-2",
    component: () => import("/app/app/pages/compramos/step-2.vue")
  },
  {
    name: "compramos-step-3___zh",
    path: "step-3",
    component: () => import("/app/app/pages/compramos/step-3.vue")
  },
  {
    name: "compramos-step-4___zh",
    path: "step-4",
    component: () => import("/app/app/pages/compramos/step-4.vue")
  },
  {
    name: "compramos-step-5___zh",
    path: "step-5",
    component: () => import("/app/app/pages/compramos/step-5.vue")
  }
]
  },
  {
    name: compramos08veRAaDYbEbqJn_tQWZuhcRtz8ABwgrDSQP6t4o0_IMeta?.name,
    path: "/fr/compramos",
    meta: compramos08veRAaDYbEbqJn_tQWZuhcRtz8ABwgrDSQP6t4o0_IMeta || {},
    component: () => import("/app/app/pages/compramos.vue"),
    children: [
  {
    name: "compramos___fr",
    path: "",
    component: () => import("/app/app/pages/compramos/index.vue")
  },
  {
    name: "compramos-step-2___fr",
    path: "step-2",
    component: () => import("/app/app/pages/compramos/step-2.vue")
  },
  {
    name: "compramos-step-3___fr",
    path: "step-3",
    component: () => import("/app/app/pages/compramos/step-3.vue")
  },
  {
    name: "compramos-step-4___fr",
    path: "step-4",
    component: () => import("/app/app/pages/compramos/step-4.vue")
  },
  {
    name: "compramos-step-5___fr",
    path: "step-5",
    component: () => import("/app/app/pages/compramos/step-5.vue")
  }
]
  },
  {
    name: "blog___es",
    path: "/blog",
    component: () => import("/app/app/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/app/app/pages/blog/index.vue")
  },
  {
    name: "blog___pt",
    path: "/pt/blog",
    component: () => import("/app/app/pages/blog/index.vue")
  },
  {
    name: "blog___zh",
    path: "/zh/blog",
    component: () => import("/app/app/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    component: () => import("/app/app/pages/blog/index.vue")
  },
  {
    name: "blog-slug___es",
    path: "/blog/:slug()",
    component: () => import("/app/app/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___en",
    path: "/en/blog/:slug()",
    component: () => import("/app/app/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___pt",
    path: "/pt/blog/:slug()",
    component: () => import("/app/app/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___zh",
    path: "/zh/blog/:slug()",
    component: () => import("/app/app/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___fr",
    path: "/fr/blog/:slug()",
    component: () => import("/app/app/pages/blog/[slug].vue")
  },
  {
    name: "cuenta___es",
    path: "/cuenta",
    meta: { ...(indexpKJ_j0pkXSnatzg99zbK_o26G4u2WaEUZFgYeTk6V5AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/index.vue")
  },
  {
    name: "cuenta___en",
    path: "/en/cuenta",
    meta: { ...(indexpKJ_j0pkXSnatzg99zbK_o26G4u2WaEUZFgYeTk6V5AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/index.vue")
  },
  {
    name: "cuenta___pt",
    path: "/pt/cuenta",
    meta: { ...(indexpKJ_j0pkXSnatzg99zbK_o26G4u2WaEUZFgYeTk6V5AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/index.vue")
  },
  {
    name: "cuenta___zh",
    path: "/zh/cuenta",
    meta: { ...(indexpKJ_j0pkXSnatzg99zbK_o26G4u2WaEUZFgYeTk6V5AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/index.vue")
  },
  {
    name: "cuenta___fr",
    path: "/fr/cuenta",
    meta: { ...(indexpKJ_j0pkXSnatzg99zbK_o26G4u2WaEUZFgYeTk6V5AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/index.vue")
  },
  {
    name: restauracionpC9gzQWJISO4SKDuTrzr6NxLccRysAqDJTciviJY8GkMeta?.name,
    path: "/restauracion",
    meta: restauracionpC9gzQWJISO4SKDuTrzr6NxLccRysAqDJTciviJY8GkMeta || {},
    component: () => import("/app/app/pages/restauracion.vue"),
    children: [
  {
    name: "restauracion___es",
    path: "",
    component: () => import("/app/app/pages/restauracion/index.vue")
  },
  {
    name: "restauracion-step-2___es",
    path: "step-2",
    component: () => import("/app/app/pages/restauracion/step-2.vue")
  },
  {
    name: "restauracion-step-3___es",
    path: "step-3",
    component: () => import("/app/app/pages/restauracion/step-3.vue")
  },
  {
    name: "restauracion-step-4___es",
    path: "step-4",
    component: () => import("/app/app/pages/restauracion/step-4.vue")
  }
]
  },
  {
    name: restauracionpC9gzQWJISO4SKDuTrzr6NxLccRysAqDJTciviJY8GkMeta?.name,
    path: "/en/restauracion",
    meta: restauracionpC9gzQWJISO4SKDuTrzr6NxLccRysAqDJTciviJY8GkMeta || {},
    component: () => import("/app/app/pages/restauracion.vue"),
    children: [
  {
    name: "restauracion___en",
    path: "",
    component: () => import("/app/app/pages/restauracion/index.vue")
  },
  {
    name: "restauracion-step-2___en",
    path: "step-2",
    component: () => import("/app/app/pages/restauracion/step-2.vue")
  },
  {
    name: "restauracion-step-3___en",
    path: "step-3",
    component: () => import("/app/app/pages/restauracion/step-3.vue")
  },
  {
    name: "restauracion-step-4___en",
    path: "step-4",
    component: () => import("/app/app/pages/restauracion/step-4.vue")
  }
]
  },
  {
    name: restauracionpC9gzQWJISO4SKDuTrzr6NxLccRysAqDJTciviJY8GkMeta?.name,
    path: "/pt/restauracion",
    meta: restauracionpC9gzQWJISO4SKDuTrzr6NxLccRysAqDJTciviJY8GkMeta || {},
    component: () => import("/app/app/pages/restauracion.vue"),
    children: [
  {
    name: "restauracion___pt",
    path: "",
    component: () => import("/app/app/pages/restauracion/index.vue")
  },
  {
    name: "restauracion-step-2___pt",
    path: "step-2",
    component: () => import("/app/app/pages/restauracion/step-2.vue")
  },
  {
    name: "restauracion-step-3___pt",
    path: "step-3",
    component: () => import("/app/app/pages/restauracion/step-3.vue")
  },
  {
    name: "restauracion-step-4___pt",
    path: "step-4",
    component: () => import("/app/app/pages/restauracion/step-4.vue")
  }
]
  },
  {
    name: restauracionpC9gzQWJISO4SKDuTrzr6NxLccRysAqDJTciviJY8GkMeta?.name,
    path: "/zh/restauracion",
    meta: restauracionpC9gzQWJISO4SKDuTrzr6NxLccRysAqDJTciviJY8GkMeta || {},
    component: () => import("/app/app/pages/restauracion.vue"),
    children: [
  {
    name: "restauracion___zh",
    path: "",
    component: () => import("/app/app/pages/restauracion/index.vue")
  },
  {
    name: "restauracion-step-2___zh",
    path: "step-2",
    component: () => import("/app/app/pages/restauracion/step-2.vue")
  },
  {
    name: "restauracion-step-3___zh",
    path: "step-3",
    component: () => import("/app/app/pages/restauracion/step-3.vue")
  },
  {
    name: "restauracion-step-4___zh",
    path: "step-4",
    component: () => import("/app/app/pages/restauracion/step-4.vue")
  }
]
  },
  {
    name: restauracionpC9gzQWJISO4SKDuTrzr6NxLccRysAqDJTciviJY8GkMeta?.name,
    path: "/fr/restauracion",
    meta: restauracionpC9gzQWJISO4SKDuTrzr6NxLccRysAqDJTciviJY8GkMeta || {},
    component: () => import("/app/app/pages/restauracion.vue"),
    children: [
  {
    name: "restauracion___fr",
    path: "",
    component: () => import("/app/app/pages/restauracion/index.vue")
  },
  {
    name: "restauracion-step-2___fr",
    path: "step-2",
    component: () => import("/app/app/pages/restauracion/step-2.vue")
  },
  {
    name: "restauracion-step-3___fr",
    path: "step-3",
    component: () => import("/app/app/pages/restauracion/step-3.vue")
  },
  {
    name: "restauracion-step-4___fr",
    path: "step-4",
    component: () => import("/app/app/pages/restauracion/step-4.vue")
  }
]
  },
  {
    name: "design-system___es",
    path: "/design-system",
    meta: design_45systemi_3OA6T2BiaZPUMI68m9W3jJWuPw7PfeLsIrXzzXpEkMeta || {},
    component: () => import("/app/app/pages/design-system.vue")
  },
  {
    name: "design-system___en",
    path: "/en/design-system",
    meta: design_45systemi_3OA6T2BiaZPUMI68m9W3jJWuPw7PfeLsIrXzzXpEkMeta || {},
    component: () => import("/app/app/pages/design-system.vue")
  },
  {
    name: "design-system___pt",
    path: "/pt/design-system",
    meta: design_45systemi_3OA6T2BiaZPUMI68m9W3jJWuPw7PfeLsIrXzzXpEkMeta || {},
    component: () => import("/app/app/pages/design-system.vue")
  },
  {
    name: "design-system___zh",
    path: "/zh/design-system",
    meta: design_45systemi_3OA6T2BiaZPUMI68m9W3jJWuPw7PfeLsIrXzzXpEkMeta || {},
    component: () => import("/app/app/pages/design-system.vue")
  },
  {
    name: "design-system___fr",
    path: "/fr/design-system",
    meta: design_45systemi_3OA6T2BiaZPUMI68m9W3jJWuPw7PfeLsIrXzzXpEkMeta || {},
    component: () => import("/app/app/pages/design-system.vue")
  },
  {
    name: "cuenta-profile___es",
    path: "/cuenta/profile",
    meta: { ...(profilec_W8OHXjvT6nF99_4GG9t9r0TT_TGxGB5VCXD7H5I34Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/profile.vue")
  },
  {
    name: "cuenta-profile___en",
    path: "/en/cuenta/profile",
    meta: { ...(profilec_W8OHXjvT6nF99_4GG9t9r0TT_TGxGB5VCXD7H5I34Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/profile.vue")
  },
  {
    name: "cuenta-profile___pt",
    path: "/pt/cuenta/profile",
    meta: { ...(profilec_W8OHXjvT6nF99_4GG9t9r0TT_TGxGB5VCXD7H5I34Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/profile.vue")
  },
  {
    name: "cuenta-profile___zh",
    path: "/zh/cuenta/profile",
    meta: { ...(profilec_W8OHXjvT6nF99_4GG9t9r0TT_TGxGB5VCXD7H5I34Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/profile.vue")
  },
  {
    name: "cuenta-profile___fr",
    path: "/fr/cuenta/profile",
    meta: { ...(profilec_W8OHXjvT6nF99_4GG9t9r0TT_TGxGB5VCXD7H5I34Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/profile.vue")
  },
  {
    name: "reset-password___es",
    path: "/reset-password",
    meta: reset_45passwordRWC8pxhff1LJdRqCJLmpSqWklySmk6cvsFKzT6u_OosMeta || {},
    component: () => import("/app/app/pages/reset-password.vue")
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    meta: reset_45passwordRWC8pxhff1LJdRqCJLmpSqWklySmk6cvsFKzT6u_OosMeta || {},
    component: () => import("/app/app/pages/reset-password.vue")
  },
  {
    name: "reset-password___pt",
    path: "/pt/reset-password",
    meta: reset_45passwordRWC8pxhff1LJdRqCJLmpSqWklySmk6cvsFKzT6u_OosMeta || {},
    component: () => import("/app/app/pages/reset-password.vue")
  },
  {
    name: "reset-password___zh",
    path: "/zh/reset-password",
    meta: reset_45passwordRWC8pxhff1LJdRqCJLmpSqWklySmk6cvsFKzT6u_OosMeta || {},
    component: () => import("/app/app/pages/reset-password.vue")
  },
  {
    name: "reset-password___fr",
    path: "/fr/reset-password",
    meta: reset_45passwordRWC8pxhff1LJdRqCJLmpSqWklySmk6cvsFKzT6u_OosMeta || {},
    component: () => import("/app/app/pages/reset-password.vue")
  },
  {
    name: "blog-tag-slug___es",
    path: "/blog/tag/:slug()",
    component: () => import("/app/app/pages/blog/tag/[slug].vue")
  },
  {
    name: "blog-tag-slug___en",
    path: "/en/blog/tag/:slug()",
    component: () => import("/app/app/pages/blog/tag/[slug].vue")
  },
  {
    name: "blog-tag-slug___pt",
    path: "/pt/blog/tag/:slug()",
    component: () => import("/app/app/pages/blog/tag/[slug].vue")
  },
  {
    name: "blog-tag-slug___zh",
    path: "/zh/blog/tag/:slug()",
    component: () => import("/app/app/pages/blog/tag/[slug].vue")
  },
  {
    name: "blog-tag-slug___fr",
    path: "/fr/blog/tag/:slug()",
    component: () => import("/app/app/pages/blog/tag/[slug].vue")
  },
  {
    name: "forgot-password___es",
    path: "/forgot-password",
    meta: forgot_45password_svvr_HXOSYgUMkqXVPpKJfwi_QEp8hjfRcKoAib3NwMeta || {},
    component: () => import("/app/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45password_svvr_HXOSYgUMkqXVPpKJfwi_QEp8hjfRcKoAib3NwMeta || {},
    component: () => import("/app/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___pt",
    path: "/pt/forgot-password",
    meta: forgot_45password_svvr_HXOSYgUMkqXVPpKJfwi_QEp8hjfRcKoAib3NwMeta || {},
    component: () => import("/app/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___zh",
    path: "/zh/forgot-password",
    meta: forgot_45password_svvr_HXOSYgUMkqXVPpKJfwi_QEp8hjfRcKoAib3NwMeta || {},
    component: () => import("/app/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___fr",
    path: "/fr/forgot-password",
    meta: forgot_45password_svvr_HXOSYgUMkqXVPpKJfwi_QEp8hjfRcKoAib3NwMeta || {},
    component: () => import("/app/app/pages/forgot-password.vue")
  },
  {
    name: "producto-slug___es",
    path: "/producto/:slug()",
    meta: _91slug_939IKtVpAoEGPyl6eNoW6Eav287llDroNYdsV6OAeNXLYMeta || {},
    component: () => import("/app/app/pages/producto/[slug].vue")
  },
  {
    name: "producto-slug___en",
    path: "/en/producto/:slug()",
    meta: _91slug_939IKtVpAoEGPyl6eNoW6Eav287llDroNYdsV6OAeNXLYMeta || {},
    component: () => import("/app/app/pages/producto/[slug].vue")
  },
  {
    name: "producto-slug___pt",
    path: "/pt/producto/:slug()",
    meta: _91slug_939IKtVpAoEGPyl6eNoW6Eav287llDroNYdsV6OAeNXLYMeta || {},
    component: () => import("/app/app/pages/producto/[slug].vue")
  },
  {
    name: "producto-slug___zh",
    path: "/zh/producto/:slug()",
    meta: _91slug_939IKtVpAoEGPyl6eNoW6Eav287llDroNYdsV6OAeNXLYMeta || {},
    component: () => import("/app/app/pages/producto/[slug].vue")
  },
  {
    name: "producto-slug___fr",
    path: "/fr/producto/:slug()",
    meta: _91slug_939IKtVpAoEGPyl6eNoW6Eav287llDroNYdsV6OAeNXLYMeta || {},
    component: () => import("/app/app/pages/producto/[slug].vue")
  },
  {
    name: "cuenta-addresses___es",
    path: "/cuenta/addresses",
    meta: { ...(addressesgA068qv_jjPyl2rEEHtcx_yKf7GRFGr4xxq8fa_EWVMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/addresses.vue")
  },
  {
    name: "cuenta-addresses___en",
    path: "/en/cuenta/addresses",
    meta: { ...(addressesgA068qv_jjPyl2rEEHtcx_yKf7GRFGr4xxq8fa_EWVMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/addresses.vue")
  },
  {
    name: "cuenta-addresses___pt",
    path: "/pt/cuenta/addresses",
    meta: { ...(addressesgA068qv_jjPyl2rEEHtcx_yKf7GRFGr4xxq8fa_EWVMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/addresses.vue")
  },
  {
    name: "cuenta-addresses___zh",
    path: "/zh/cuenta/addresses",
    meta: { ...(addressesgA068qv_jjPyl2rEEHtcx_yKf7GRFGr4xxq8fa_EWVMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/addresses.vue")
  },
  {
    name: "cuenta-addresses___fr",
    path: "/fr/cuenta/addresses",
    meta: { ...(addressesgA068qv_jjPyl2rEEHtcx_yKf7GRFGr4xxq8fa_EWVMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/addresses.vue")
  },
  {
    name: "blog-preview-id___es",
    path: "/blog/preview/:id()",
    meta: _91id_93ljw4oHscF_0JU1NjE84NcoFbmBhNrj_j8LGCoKm_QN4Meta || {},
    component: () => import("/app/app/pages/blog/preview/[id].vue")
  },
  {
    name: "blog-preview-id___en",
    path: "/en/blog/preview/:id()",
    meta: _91id_93ljw4oHscF_0JU1NjE84NcoFbmBhNrj_j8LGCoKm_QN4Meta || {},
    component: () => import("/app/app/pages/blog/preview/[id].vue")
  },
  {
    name: "blog-preview-id___pt",
    path: "/pt/blog/preview/:id()",
    meta: _91id_93ljw4oHscF_0JU1NjE84NcoFbmBhNrj_j8LGCoKm_QN4Meta || {},
    component: () => import("/app/app/pages/blog/preview/[id].vue")
  },
  {
    name: "blog-preview-id___zh",
    path: "/zh/blog/preview/:id()",
    meta: _91id_93ljw4oHscF_0JU1NjE84NcoFbmBhNrj_j8LGCoKm_QN4Meta || {},
    component: () => import("/app/app/pages/blog/preview/[id].vue")
  },
  {
    name: "blog-preview-id___fr",
    path: "/fr/blog/preview/:id()",
    meta: _91id_93ljw4oHscF_0JU1NjE84NcoFbmBhNrj_j8LGCoKm_QN4Meta || {},
    component: () => import("/app/app/pages/blog/preview/[id].vue")
  },
  {
    name: "cuenta-orders-id___es",
    path: "/cuenta/orders/:id()",
    meta: { ...(_91id_93E4_n4ZvBQs2u9XLfe7atCPLMbqNB3avJYwMCa45Cs9UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/orders/[id].vue")
  },
  {
    name: "cuenta-orders-id___en",
    path: "/en/cuenta/orders/:id()",
    meta: { ...(_91id_93E4_n4ZvBQs2u9XLfe7atCPLMbqNB3avJYwMCa45Cs9UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/orders/[id].vue")
  },
  {
    name: "cuenta-orders-id___pt",
    path: "/pt/cuenta/orders/:id()",
    meta: { ...(_91id_93E4_n4ZvBQs2u9XLfe7atCPLMbqNB3avJYwMCa45Cs9UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/orders/[id].vue")
  },
  {
    name: "cuenta-orders-id___zh",
    path: "/zh/cuenta/orders/:id()",
    meta: { ...(_91id_93E4_n4ZvBQs2u9XLfe7atCPLMbqNB3avJYwMCa45Cs9UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/orders/[id].vue")
  },
  {
    name: "cuenta-orders-id___fr",
    path: "/fr/cuenta/orders/:id()",
    meta: { ...(_91id_93E4_n4ZvBQs2u9XLfe7atCPLMbqNB3avJYwMCa45Cs9UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/orders/[id].vue")
  },
  {
    name: "cuenta-orders___es",
    path: "/cuenta/orders",
    meta: { ...(indexA1Z4n6yr5Usqsa82fOa6jRmBnfpCBYIZRndEOZ6Pof0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/orders/index.vue")
  },
  {
    name: "cuenta-orders___en",
    path: "/en/cuenta/orders",
    meta: { ...(indexA1Z4n6yr5Usqsa82fOa6jRmBnfpCBYIZRndEOZ6Pof0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/orders/index.vue")
  },
  {
    name: "cuenta-orders___pt",
    path: "/pt/cuenta/orders",
    meta: { ...(indexA1Z4n6yr5Usqsa82fOa6jRmBnfpCBYIZRndEOZ6Pof0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/orders/index.vue")
  },
  {
    name: "cuenta-orders___zh",
    path: "/zh/cuenta/orders",
    meta: { ...(indexA1Z4n6yr5Usqsa82fOa6jRmBnfpCBYIZRndEOZ6Pof0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/orders/index.vue")
  },
  {
    name: "cuenta-orders___fr",
    path: "/fr/cuenta/orders",
    meta: { ...(indexA1Z4n6yr5Usqsa82fOa6jRmBnfpCBYIZRndEOZ6Pof0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/orders/index.vue")
  },
  {
    name: "blog-category-slug___es",
    path: "/blog/category/:slug()",
    component: () => import("/app/app/pages/blog/category/[slug].vue")
  },
  {
    name: "blog-category-slug___en",
    path: "/en/blog/category/:slug()",
    component: () => import("/app/app/pages/blog/category/[slug].vue")
  },
  {
    name: "blog-category-slug___pt",
    path: "/pt/blog/category/:slug()",
    component: () => import("/app/app/pages/blog/category/[slug].vue")
  },
  {
    name: "blog-category-slug___zh",
    path: "/zh/blog/category/:slug()",
    component: () => import("/app/app/pages/blog/category/[slug].vue")
  },
  {
    name: "blog-category-slug___fr",
    path: "/fr/blog/category/:slug()",
    component: () => import("/app/app/pages/blog/category/[slug].vue")
  },
  {
    name: "cuenta-afiliados___es",
    path: "/cuenta/afiliados",
    meta: { ...(index3Qvr8laYRvJ5VA5BVbMRS1qnrDNW4aif7Ey_t9gwaGsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/index.vue")
  },
  {
    name: "cuenta-afiliados___en",
    path: "/en/cuenta/afiliados",
    meta: { ...(index3Qvr8laYRvJ5VA5BVbMRS1qnrDNW4aif7Ey_t9gwaGsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/index.vue")
  },
  {
    name: "cuenta-afiliados___pt",
    path: "/pt/cuenta/afiliados",
    meta: { ...(index3Qvr8laYRvJ5VA5BVbMRS1qnrDNW4aif7Ey_t9gwaGsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/index.vue")
  },
  {
    name: "cuenta-afiliados___zh",
    path: "/zh/cuenta/afiliados",
    meta: { ...(index3Qvr8laYRvJ5VA5BVbMRS1qnrDNW4aif7Ey_t9gwaGsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/index.vue")
  },
  {
    name: "cuenta-afiliados___fr",
    path: "/fr/cuenta/afiliados",
    meta: { ...(index3Qvr8laYRvJ5VA5BVbMRS1qnrDNW4aif7Ey_t9gwaGsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/index.vue")
  },
  {
    name: "cuenta-afiliados-pagos___es",
    path: "/cuenta/afiliados/pagos",
    meta: { ...(pagosL_oZeUl7p21d0CMb1Zh25xxkvjaOjro2n_k3zXQIN28Meta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/pagos.vue")
  },
  {
    name: "cuenta-afiliados-pagos___en",
    path: "/en/cuenta/afiliados/pagos",
    meta: { ...(pagosL_oZeUl7p21d0CMb1Zh25xxkvjaOjro2n_k3zXQIN28Meta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/pagos.vue")
  },
  {
    name: "cuenta-afiliados-pagos___pt",
    path: "/pt/cuenta/afiliados/pagos",
    meta: { ...(pagosL_oZeUl7p21d0CMb1Zh25xxkvjaOjro2n_k3zXQIN28Meta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/pagos.vue")
  },
  {
    name: "cuenta-afiliados-pagos___zh",
    path: "/zh/cuenta/afiliados/pagos",
    meta: { ...(pagosL_oZeUl7p21d0CMb1Zh25xxkvjaOjro2n_k3zXQIN28Meta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/pagos.vue")
  },
  {
    name: "cuenta-afiliados-pagos___fr",
    path: "/fr/cuenta/afiliados/pagos",
    meta: { ...(pagosL_oZeUl7p21d0CMb1Zh25xxkvjaOjro2n_k3zXQIN28Meta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/pagos.vue")
  },
  {
    name: "cuenta-sell-orders-id___es",
    path: "/cuenta/sell-orders/:id()",
    meta: { ...(_91id_93F7rcEIxtWJtG6XKmI0DYbJQIu9Wb44c5siLXxLsY948Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/sell-orders/[id].vue")
  },
  {
    name: "cuenta-sell-orders-id___en",
    path: "/en/cuenta/sell-orders/:id()",
    meta: { ...(_91id_93F7rcEIxtWJtG6XKmI0DYbJQIu9Wb44c5siLXxLsY948Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/sell-orders/[id].vue")
  },
  {
    name: "cuenta-sell-orders-id___pt",
    path: "/pt/cuenta/sell-orders/:id()",
    meta: { ...(_91id_93F7rcEIxtWJtG6XKmI0DYbJQIu9Wb44c5siLXxLsY948Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/sell-orders/[id].vue")
  },
  {
    name: "cuenta-sell-orders-id___zh",
    path: "/zh/cuenta/sell-orders/:id()",
    meta: { ...(_91id_93F7rcEIxtWJtG6XKmI0DYbJQIu9Wb44c5siLXxLsY948Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/sell-orders/[id].vue")
  },
  {
    name: "cuenta-sell-orders-id___fr",
    path: "/fr/cuenta/sell-orders/:id()",
    meta: { ...(_91id_93F7rcEIxtWJtG6XKmI0DYbJQIu9Wb44c5siLXxLsY948Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/sell-orders/[id].vue")
  },
  {
    name: "cuenta-afiliados-pedidos___es",
    path: "/cuenta/afiliados/pedidos",
    meta: { ...(pedidosnKcc6GeRUWing_9XZR_qlQ4l0Z8_CeMZhg0G1fIMAqsMeta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/pedidos.vue")
  },
  {
    name: "cuenta-afiliados-pedidos___en",
    path: "/en/cuenta/afiliados/pedidos",
    meta: { ...(pedidosnKcc6GeRUWing_9XZR_qlQ4l0Z8_CeMZhg0G1fIMAqsMeta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/pedidos.vue")
  },
  {
    name: "cuenta-afiliados-pedidos___pt",
    path: "/pt/cuenta/afiliados/pedidos",
    meta: { ...(pedidosnKcc6GeRUWing_9XZR_qlQ4l0Z8_CeMZhg0G1fIMAqsMeta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/pedidos.vue")
  },
  {
    name: "cuenta-afiliados-pedidos___zh",
    path: "/zh/cuenta/afiliados/pedidos",
    meta: { ...(pedidosnKcc6GeRUWing_9XZR_qlQ4l0Z8_CeMZhg0G1fIMAqsMeta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/pedidos.vue")
  },
  {
    name: "cuenta-afiliados-pedidos___fr",
    path: "/fr/cuenta/afiliados/pedidos",
    meta: { ...(pedidosnKcc6GeRUWing_9XZR_qlQ4l0Z8_CeMZhg0G1fIMAqsMeta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/pedidos.vue")
  },
  {
    name: "cuenta-sell-orders___es",
    path: "/cuenta/sell-orders",
    meta: { ...(indexaZd5suxscPL8PeEioAeZellF6W0buzj0w6lxtDdr1VgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/sell-orders/index.vue")
  },
  {
    name: "cuenta-sell-orders___en",
    path: "/en/cuenta/sell-orders",
    meta: { ...(indexaZd5suxscPL8PeEioAeZellF6W0buzj0w6lxtDdr1VgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/sell-orders/index.vue")
  },
  {
    name: "cuenta-sell-orders___pt",
    path: "/pt/cuenta/sell-orders",
    meta: { ...(indexaZd5suxscPL8PeEioAeZellF6W0buzj0w6lxtDdr1VgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/sell-orders/index.vue")
  },
  {
    name: "cuenta-sell-orders___zh",
    path: "/zh/cuenta/sell-orders",
    meta: { ...(indexaZd5suxscPL8PeEioAeZellF6W0buzj0w6lxtDdr1VgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/sell-orders/index.vue")
  },
  {
    name: "cuenta-sell-orders___fr",
    path: "/fr/cuenta/sell-orders",
    meta: { ...(indexaZd5suxscPL8PeEioAeZellF6W0buzj0w6lxtDdr1VgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/sell-orders/index.vue")
  },
  {
    name: "cuenta-afiliados-disputas___es",
    path: "/cuenta/afiliados/disputas",
    meta: { ...(disputasFhwRzT4lspSzAcgDytBL8Ofjob_U7HTwjIvRuwT2ceQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/disputas.vue")
  },
  {
    name: "cuenta-afiliados-disputas___en",
    path: "/en/cuenta/afiliados/disputas",
    meta: { ...(disputasFhwRzT4lspSzAcgDytBL8Ofjob_U7HTwjIvRuwT2ceQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/disputas.vue")
  },
  {
    name: "cuenta-afiliados-disputas___pt",
    path: "/pt/cuenta/afiliados/disputas",
    meta: { ...(disputasFhwRzT4lspSzAcgDytBL8Ofjob_U7HTwjIvRuwT2ceQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/disputas.vue")
  },
  {
    name: "cuenta-afiliados-disputas___zh",
    path: "/zh/cuenta/afiliados/disputas",
    meta: { ...(disputasFhwRzT4lspSzAcgDytBL8Ofjob_U7HTwjIvRuwT2ceQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/disputas.vue")
  },
  {
    name: "cuenta-afiliados-disputas___fr",
    path: "/fr/cuenta/afiliados/disputas",
    meta: { ...(disputasFhwRzT4lspSzAcgDytBL8Ofjob_U7HTwjIvRuwT2ceQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/disputas.vue")
  },
  {
    name: "cuenta-repair-orders-id___es",
    path: "/cuenta/repair-orders/:id()",
    meta: { ...(_91id_93bRMjVP6vwniJw7xx_J3wvBqfQJwRuBzTt0V2iOkebU4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/repair-orders/[id].vue")
  },
  {
    name: "cuenta-repair-orders-id___en",
    path: "/en/cuenta/repair-orders/:id()",
    meta: { ...(_91id_93bRMjVP6vwniJw7xx_J3wvBqfQJwRuBzTt0V2iOkebU4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/repair-orders/[id].vue")
  },
  {
    name: "cuenta-repair-orders-id___pt",
    path: "/pt/cuenta/repair-orders/:id()",
    meta: { ...(_91id_93bRMjVP6vwniJw7xx_J3wvBqfQJwRuBzTt0V2iOkebU4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/repair-orders/[id].vue")
  },
  {
    name: "cuenta-repair-orders-id___zh",
    path: "/zh/cuenta/repair-orders/:id()",
    meta: { ...(_91id_93bRMjVP6vwniJw7xx_J3wvBqfQJwRuBzTt0V2iOkebU4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/repair-orders/[id].vue")
  },
  {
    name: "cuenta-repair-orders-id___fr",
    path: "/fr/cuenta/repair-orders/:id()",
    meta: { ...(_91id_93bRMjVP6vwniJw7xx_J3wvBqfQJwRuBzTt0V2iOkebU4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/repair-orders/[id].vue")
  },
  {
    name: "cuenta-afiliados-solicitud___es",
    path: "/cuenta/afiliados/solicitud",
    meta: { ...(solicitudqkjloHtiYXll1Madjfahce6HB4qMt5khUAdw9Wv1bHwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/solicitud.vue")
  },
  {
    name: "cuenta-afiliados-solicitud___en",
    path: "/en/cuenta/afiliados/solicitud",
    meta: { ...(solicitudqkjloHtiYXll1Madjfahce6HB4qMt5khUAdw9Wv1bHwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/solicitud.vue")
  },
  {
    name: "cuenta-afiliados-solicitud___pt",
    path: "/pt/cuenta/afiliados/solicitud",
    meta: { ...(solicitudqkjloHtiYXll1Madjfahce6HB4qMt5khUAdw9Wv1bHwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/solicitud.vue")
  },
  {
    name: "cuenta-afiliados-solicitud___zh",
    path: "/zh/cuenta/afiliados/solicitud",
    meta: { ...(solicitudqkjloHtiYXll1Madjfahce6HB4qMt5khUAdw9Wv1bHwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/solicitud.vue")
  },
  {
    name: "cuenta-afiliados-solicitud___fr",
    path: "/fr/cuenta/afiliados/solicitud",
    meta: { ...(solicitudqkjloHtiYXll1Madjfahce6HB4qMt5khUAdw9Wv1bHwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/afiliados/solicitud.vue")
  },
  {
    name: "cuenta-repair-orders___es",
    path: "/cuenta/repair-orders",
    meta: { ...(indexuyjqovXJbNEALsC2UmwLPsPoPmtMcQ_BiO5ISa81DRcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/repair-orders/index.vue")
  },
  {
    name: "cuenta-repair-orders___en",
    path: "/en/cuenta/repair-orders",
    meta: { ...(indexuyjqovXJbNEALsC2UmwLPsPoPmtMcQ_BiO5ISa81DRcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/repair-orders/index.vue")
  },
  {
    name: "cuenta-repair-orders___pt",
    path: "/pt/cuenta/repair-orders",
    meta: { ...(indexuyjqovXJbNEALsC2UmwLPsPoPmtMcQ_BiO5ISa81DRcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/repair-orders/index.vue")
  },
  {
    name: "cuenta-repair-orders___zh",
    path: "/zh/cuenta/repair-orders",
    meta: { ...(indexuyjqovXJbNEALsC2UmwLPsPoPmtMcQ_BiO5ISa81DRcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/repair-orders/index.vue")
  },
  {
    name: "cuenta-repair-orders___fr",
    path: "/fr/cuenta/repair-orders",
    meta: { ...(indexuyjqovXJbNEALsC2UmwLPsPoPmtMcQ_BiO5ISa81DRcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/app/pages/cuenta/repair-orders/index.vue")
  },
  {
    name: "cuenta-afiliados-comisiones___es",
    path: "/cuenta/afiliados/comisiones",
    meta: { ...(comisionesZpwqZB2EL06Wa38MWYx3SLWWBFAjxr_3etcjkBkfFZ4Meta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/comisiones.vue")
  },
  {
    name: "cuenta-afiliados-comisiones___en",
    path: "/en/cuenta/afiliados/comisiones",
    meta: { ...(comisionesZpwqZB2EL06Wa38MWYx3SLWWBFAjxr_3etcjkBkfFZ4Meta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/comisiones.vue")
  },
  {
    name: "cuenta-afiliados-comisiones___pt",
    path: "/pt/cuenta/afiliados/comisiones",
    meta: { ...(comisionesZpwqZB2EL06Wa38MWYx3SLWWBFAjxr_3etcjkBkfFZ4Meta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/comisiones.vue")
  },
  {
    name: "cuenta-afiliados-comisiones___zh",
    path: "/zh/cuenta/afiliados/comisiones",
    meta: { ...(comisionesZpwqZB2EL06Wa38MWYx3SLWWBFAjxr_3etcjkBkfFZ4Meta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/comisiones.vue")
  },
  {
    name: "cuenta-afiliados-comisiones___fr",
    path: "/fr/cuenta/afiliados/comisiones",
    meta: { ...(comisionesZpwqZB2EL06Wa38MWYx3SLWWBFAjxr_3etcjkBkfFZ4Meta || {}), ...{"middleware":["auth","affiliate"]} },
    component: () => import("/app/app/pages/cuenta/afiliados/comisiones.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/pt/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/zh/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]